export enum FanControlMethod {
    Temperature = "Temperature",
    Pressure = "Pressure",
}